import { createAsyncThunk } from '@reduxjs/toolkit'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams } from 'src/mentor/services'

const inFlightDoctorRecommendedHealthEntitiesRequests = new Map()
const doctorRecommendedHealthEntitiesCache = new Map()
const DOCTOR_RECOMMENDED_HEALTH_ENTITIES_CACHE_TTL_MS = 5 * 60 * 1000

export const getDoctorRecommendedHealthEntities = createAsyncThunk(
  'doctorRecommendedHealthEntities/getData',
  async ({ clinicBrandId, limit = 15 }, { rejectWithValue, getState }) => {
    getDoctorRecommendedHealthEntities.pending()
    const { doctorRecommendedHealthEntitiesStore } = getState()
    const doctorRecommendedHealthEntities =
      doctorRecommendedHealthEntitiesStore?.doctorRecommendedHealthEntities?.data

    if (
      !!doctorRecommendedHealthEntities &&
      doctorRecommendedHealthEntities?.clinicBrandId === clinicBrandId
    ) {
      doctorRecommendedHealthEntitiesCache.set(`${clinicBrandId || ''}::${limit || 15}`, {
        data: doctorRecommendedHealthEntities,
        timestamp: Date.now(),
      })
      return doctorRecommendedHealthEntities
    }

    const requestKey = `${clinicBrandId || ''}::${limit || 15}`
    const cached = doctorRecommendedHealthEntitiesCache.get(requestKey)
    if (cached && Date.now() - cached.timestamp < DOCTOR_RECOMMENDED_HEALTH_ENTITIES_CACHE_TTL_MS) {
      return cached.data
    }

    if (inFlightDoctorRecommendedHealthEntitiesRequests.has(requestKey)) {
      return inFlightDoctorRecommendedHealthEntitiesRequests.get(requestKey)
    }

    const requestPromise = (async () => {
      const resp = await getMPDataWithParams('/api/secure/practitioner/clinical/health-entity/recommended', {
        'clinic-brand-id': clinicBrandId,
        limit: 15,
      })
      if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
        const normalizedData = { ...(resp?.data?.data || {}), clinicBrandId }
        doctorRecommendedHealthEntitiesCache.set(requestKey, {
          data: normalizedData,
          timestamp: Date.now(),
        })
        return normalizedData
      }
      return rejectWithValue('Failed to fetch data')
    })()

    inFlightDoctorRecommendedHealthEntitiesRequests.set(requestKey, requestPromise)
    try {
      return await requestPromise
    } finally {
      inFlightDoctorRecommendedHealthEntitiesRequests.delete(requestKey)
    }
  },
)
